var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useState } from 'react';
import moment from 'moment';
import { Avatar, Box, Button, Chip, CircularProgress, Dialog, IconButton, InputAdornment, Menu, MenuItem, Pagination, Tab, Tabs, TextField, Tooltip, Typography, } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import DevicesOtherIcon from '@mui/icons-material/DevicesOther';
import { useAppSelector } from 'hooks/reduxHooks';
import { Roles } from 'globals/enums';
import { ALERT_STATUS, RECENT_ALERTS_PAGE_SIZE, VALID_ALERT_TRANSITIONS, fetchRecentAlertsByStatus, isValidAlertTransition, updateAlertActionService, } from './SeniorCard.service';
var BRAND = '#32602F';
var BRAND_DARK = '#244022';
var STATUS_TABS = [
    { value: ALERT_STATUS.ACTIVE, label: 'Active' },
    { value: ALERT_STATUS.ACKNOWLEDGED, label: 'Acknowledged' },
    { value: ALERT_STATUS.DISMISSED, label: 'Dismissed' },
    { value: ALERT_STATUS.RESOLVED, label: 'Resolved' },
    { value: ALERT_STATUS.ARCHIVED, label: 'Archived' },
];
// Action-verb labels shown in the Change status dropdown
var ACTION_LABEL = {
    ACTIVE: 'Active',
    ACKNOWLEDGED: 'Acknowledge',
    DISMISSED: 'Dismiss',
    RESOLVED: 'Resolve',
    ARCHIVED: 'Archive',
};
// Acknowledge = blue, Dismiss = red, Resolve = green, Archive = grey
var ACTION_COLOR = {
    ACTIVE: '#64748b',
    ACKNOWLEDGED: '#2563eb',
    DISMISSED: '#dc2626',
    RESOLVED: '#16a34a',
    ARCHIVED: '#64748b',
};
var RISK_STYLE = {
    high: { label: 'HIGH SEVERITY', bar: '#dc2626', chipBg: '#fee2e2', chipColor: '#dc2626' },
    moderate: { label: 'MODERATE SEVERITY', bar: '#f59e0b', chipBg: '#fef3c7', chipColor: '#b45309' },
    stable: { label: 'LOW SEVERITY', bar: '#16a34a', chipBg: '#dcfce7', chipColor: '#15803d' },
    default: { label: 'INFO', bar: '#94a3b8', chipBg: '#f1f5f9', chipColor: '#475569' },
};
/* ------------------------- API response → UI mapping ----------------------- */
// ASSUMPTION: field names below are guesses with fallbacks. Once you share a
// sample alert from the API, adjust ONLY this function.
var toMoment = function (value) {
    if (value === null || value === undefined || value === '')
        return null;
    if (typeof value === 'number') {
        // seconds vs milliseconds
        return moment(value < 1e11 ? value * 1000 : value);
    }
    var m = moment(value);
    return m.isValid() ? m : null;
};
// "SLEEP_SCORE" → "Sleep Score"
var formatEnumLabel = function (value) {
    return value
        ? value
            .toLowerCase()
            .split('_')
            .filter(Boolean)
            .map(function (w) { return w[0].toUpperCase() + w.slice(1); })
            .join(' ')
        : '-';
};
// Alert colour follows the API's `severity`
var SEVERITY_TO_RISK = {
    RED: 'high',
    YELLOW: 'moderate',
    GREEN: 'stable',
};
var mapAlert = function (raw, fallbackStatus) {
    var _a, _b, _c, _d, _e, _f;
    var severity = String((_a = raw === null || raw === void 0 ? void 0 : raw.severity) !== null && _a !== void 0 ? _a : '').toUpperCase();
    var readingAt = toMoment(raw === null || raw === void 0 ? void 0 : raw.lastReadingAt);
    var createdAt = toMoment((_b = raw === null || raw === void 0 ? void 0 : raw.createdAt) !== null && _b !== void 0 ? _b : raw === null || raw === void 0 ? void 0 : raw.created_at);
    // seniorName arrives as "digantmohanty|mohanty|digant" — show the first part
    var displayName = String((_c = raw === null || raw === void 0 ? void 0 : raw.seniorName) !== null && _c !== void 0 ? _c : '')
        .split('|')[0]
        .trim() || 'Unknown Senior';
    return {
        id: (_e = (_d = raw === null || raw === void 0 ? void 0 : raw.alertId) !== null && _d !== void 0 ? _d : raw === null || raw === void 0 ? void 0 : raw.id) !== null && _e !== void 0 ? _e : raw === null || raw === void 0 ? void 0 : raw.alert_id,
        seniorName: displayName,
        risk: (_f = SEVERITY_TO_RISK[severity]) !== null && _f !== void 0 ? _f : 'default',
        category: formatEnumLabel(raw === null || raw === void 0 ? void 0 : raw.category),
        lastReading: readingAt ? "Last reading ".concat(readingAt.fromNow()) : 'No recent reading',
        lastReadingFull: readingAt ? "Reading at ".concat(readingAt.format('MMM D, YYYY, h:mm:ss A')) : 'No reading available',
        message: (raw === null || raw === void 0 ? void 0 : raw.message) || (raw === null || raw === void 0 ? void 0 : raw.title) || (raw === null || raw === void 0 ? void 0 : raw.rule_name) || 'Alert',
        occurredAt: createdAt ? createdAt.format('MMM D, h:mm A') : '-',
        source: formatEnumLabel(raw === null || raw === void 0 ? void 0 : raw.ruleClassification),
        status: ((raw === null || raw === void 0 ? void 0 : raw.status) ? String(raw.status).toUpperCase() : fallbackStatus),
    };
};
var initials = function (name) {
    var parts = name
        .trim()
        .split(' ')
        .filter(function (p) { return p && !p.startsWith('('); });
    if (parts.length === 0)
        return '?';
    if (parts.length === 1)
        return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};
var RecentAlertsDialog = function (_a) {
    var open = _a.open, onClose = _a.onClose;
    var role = useAppSelector(function (state) { return state.auth.roleConfig.role; });
    var isStatusChangeDisabled = role === Roles.FACILITY_AGENT;
    var _b = useState(ALERT_STATUS.ACTIVE), tab = _b[0], setTab = _b[1];
    var _c = useState(1), page = _c[0], setPage = _c[1];
    var _d = useState(''), query = _d[0], setQuery = _d[1];
    var _e = useState(''), debouncedQuery = _e[0], setDebouncedQuery = _e[1];
    var _f = useState([]), alerts = _f[0], setAlerts = _f[1];
    var _g = useState(null), total = _g[0], setTotal = _g[1];
    var _h = useState(false), hasMore = _h[0], setHasMore = _h[1];
    var _j = useState(false), loading = _j[0], setLoading = _j[1];
    var _k = useState(false), error = _k[0], setError = _k[1];
    var _l = useState(0), reloadKey = _l[0], setReloadKey = _l[1];
    var _m = useState(null), menuAnchor = _m[0], setMenuAnchor = _m[1];
    var _o = useState(null), menuAlert = _o[0], setMenuAlert = _o[1];
    var _p = useState(null), actionLoadingId = _p[0], setActionLoadingId = _p[1];
    // Debounce search (same rule as the dashboard: empty or 3+ chars)
    useEffect(function () {
        var t = setTimeout(function () {
            var q = query.trim();
            if (q.length === 0 || q.length >= 3) {
                setDebouncedQuery(q);
                setPage(1);
            }
        }, 500);
        return function () { return clearTimeout(t); };
    }, [query]);
    // Fetch the current page whenever status / page / search changes
    useEffect(function () {
        if (!open)
            return;
        var cancelled = false;
        setLoading(true);
        setError(false);
        fetchRecentAlertsByStatus(tab, page, RECENT_ALERTS_PAGE_SIZE, debouncedQuery)
            .then(function (res) {
            if (cancelled)
                return;
            setAlerts(res.alerts.map(function (a) { return mapAlert(a, tab); }));
            setTotal(res.total);
            setHasMore(res.hasMore);
        })
            .catch(function () {
            if (cancelled)
                return;
            setError(true);
            setAlerts([]);
            setTotal(null);
            setHasMore(false);
        })
            .finally(function () {
            if (!cancelled)
                setLoading(false);
        });
        return function () {
            cancelled = true;
        };
    }, [open, tab, page, debouncedQuery, reloadKey]);
    // Reset to first page/status each time the popup is reopened
    useEffect(function () {
        if (open) {
            setTab(ALERT_STATUS.ACTIVE);
            setPage(1);
            setQuery('');
            setDebouncedQuery('');
        }
    }, [open]);
    var totalPages = total !== null ? Math.max(1, Math.ceil(total / RECENT_ALERTS_PAGE_SIZE)) : null;
    var startIdx = (page - 1) * RECENT_ALERTS_PAGE_SIZE;
    var rangeText = "".concat(startIdx + 1, "\u2013").concat(startIdx + alerts.length);
    var totalText = total !== null ? "of ".concat(total, " ") : '';
    var summaryText = alerts.length === 0 ? 'No alerts to show' : "Showing ".concat(rangeText, " ").concat(totalText).concat(tab, " alerts");
    var openMenu = function (e, alert) {
        setMenuAnchor(e.currentTarget);
        setMenuAlert(alert);
    };
    var closeMenu = function () {
        setMenuAnchor(null);
        setMenuAlert(null);
    };
    var changeStatus = useCallback(function (target) { return __awaiter(void 0, void 0, void 0, function () {
        var alert, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    alert = menuAlert;
                    closeMenu();
                    if (isStatusChangeDisabled)
                        return [2 /*return*/];
                    if (!alert || !isValidAlertTransition(alert.status, target))
                        return [2 /*return*/];
                    setActionLoadingId(alert.id);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, updateAlertActionService(alert.id, target)];
                case 2:
                    _b.sent();
                    // If that was the last row on this page, step back one page
                    if (alerts.length === 1 && page > 1)
                        setPage(page - 1);
                    else
                        setReloadKey(function (k) { return k + 1; });
                    return [3 /*break*/, 5];
                case 3:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 4:
                    setActionLoadingId(null);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [menuAlert, alerts.length, page, isStatusChangeDisabled]);
    var menuOptions = menuAlert ? VALID_ALERT_TRANSITIONS[menuAlert.status] || [] : [];
    return (_jsxs(Dialog, { open: open, onClose: onClose, fullWidth: true, maxWidth: 'lg', PaperProps: {
            sx: {
                borderRadius: '20px',
                overflow: 'hidden',
                backgroundColor: '#f8fafc',
                height: { xs: '92vh', md: '82vh' },
                maxHeight: 800,
            },
        }, children: [_jsxs(Box, { sx: {
                    backgroundColor: BRAND,
                    color: '#fff',
                    px: 3,
                    py: 1.25,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 2,
                }, children: [_jsx(Box, { sx: { display: 'flex', alignItems: 'baseline', gap: 1.25, minWidth: 0, flexWrap: 'wrap' }, children: _jsx(Typography, { component: 'h2', noWrap: true, sx: { fontSize: '1.05rem', fontWeight: 700, lineHeight: 1.3 }, children: "Global Alerts Feed" }) }), _jsx(IconButton, { size: 'small', onClick: onClose, "aria-label": 'Close', sx: { color: '#fff', backgroundColor: 'rgba(0,0,0,0.2)',
                            '&:hover': { backgroundColor: 'rgba(0,0,0,0.35)' } }, children: _jsx(CloseIcon, { fontSize: 'small' }) })] }), _jsxs(Box, { sx: { px: 3, pt: 2.5, display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }, children: [_jsx(Tabs, { value: tab, onChange: function (_, v) {
                            setTab(v);
                            setPage(1);
                        }, variant: 'fullWidth', TabIndicatorProps: { style: { display: 'none' } }, sx: {
                            backgroundColor: '#e2e8f0',
                            borderRadius: '50px',
                            p: '4px',
                            minHeight: 44,
                            '& .MuiTab-root': {
                                minHeight: 36,
                                borderRadius: '50px',
                                textTransform: 'none',
                                fontSize: '0.78rem',
                                fontWeight: 700,
                                color: '#64748b',
                                transition: 'all 0.2s ease',
                            },
                            '& .Mui-selected': {
                                backgroundColor: '#fff',
                                color: "".concat(BRAND_DARK, " !important"),
                                boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
                            },
                        }, children: STATUS_TABS.map(function (t) { return (_jsx(Tab, { value: t.value, 
                            // Total is only known for the selected status (one API call per status)
                            label: tab === t.value && total !== null ? "".concat(t.label, " (").concat(total, ")") : t.label }, t.value)); }) }), _jsx(Box, { sx: { display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap', mt: 2, mb: 2 }, children: _jsx(TextField, { size: 'small', value: query, onChange: function (e) { return setQuery(e.target.value); }, placeholder: 'Search senior name', sx: {
                                flex: 1,
                                minWidth: 260,
                                maxWidth: 520,
                                backgroundColor: '#fff',
                                borderRadius: '8px',
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': { borderColor: '#e2e8f0' },
                                    '&:hover fieldset': { borderColor: '#cbd5e1' },
                                    '&.Mui-focused fieldset': { borderColor: BRAND },
                                },
                            }, InputProps: {
                                startAdornment: (_jsx(InputAdornment, { position: 'start', children: _jsx(SearchIcon, { sx: { color: '#64748b' } }) })),
                                endAdornment: query && (_jsx(InputAdornment, { position: 'end', children: _jsx(IconButton, { size: 'small', edge: 'end', onClick: function () { return setQuery(''); }, children: _jsx(ClearIcon, { sx: { color: '#64748b' } }) }) })),
                            } }) }), _jsx(Box, { sx: { flex: 1, overflowY: 'auto', pr: 0.5, pb: 1 }, children: loading ? (_jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', alignItems: 'center', py: 8 }, children: [_jsx(CircularProgress, { size: 36, sx: { color: BRAND } }), _jsx(Typography, { component: 'div', sx: { mt: 2, color: '#64748b', fontSize: '0.85rem' }, children: "Loading alerts..." })] })) : error ? (_jsxs(Box, { sx: {
                                textAlign: 'center',
                                color: '#b91c1c',
                                py: 8,
                                backgroundColor: '#fff',
                                borderRadius: '12px',
                                border: '1px solid #fecaca',
                            }, children: [_jsx(Typography, { sx: { fontWeight: 600 }, children: "Couldn't load alerts" }), _jsx(Button, { size: 'small', onClick: function () { return setReloadKey(function (k) { return k + 1; }); }, sx: { mt: 1, textTransform: 'none', color: BRAND, fontWeight: 700 }, children: "Try again" })] })) : alerts.length === 0 ? (_jsx(Box, { sx: {
                                textAlign: 'center',
                                color: '#64748b',
                                py: 8,
                                backgroundColor: '#fff',
                                borderRadius: '12px',
                                border: '1px solid #e2e8f0',
                            }, children: _jsx(Typography, { sx: { fontWeight: 600 }, children: "No alerts found" }) })) : (alerts.map(function (alert, idx) {
                            var _a;
                            var risk = RISK_STYLE[alert.risk];
                            var options = VALID_ALERT_TRANSITIONS[alert.status] || [];
                            var rowLoading = actionLoadingId === alert.id;
                            return (_jsxs(Box, { sx: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 2,
                                    backgroundColor: '#fff',
                                    border: '1px solid #e2e8f0',
                                    borderLeft: "6px solid ".concat(risk.bar),
                                    borderRadius: '12px',
                                    p: 2,
                                    mb: 1.5,
                                    transition: 'box-shadow 0.2s ease',
                                    '&:hover': { boxShadow: '0 4px 16px rgba(0,0,0,0.08)' },
                                }, children: [_jsx(Avatar, { sx: {
                                            width: 44,
                                            height: 44,
                                            fontSize: '0.85rem',
                                            fontWeight: 700,
                                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                        }, children: initials(alert.seniorName) }), _jsxs(Box, { sx: { flex: 1, minWidth: 0 }, children: [_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }, children: [_jsx(Typography, { component: 'div', sx: { fontWeight: 700, color: '#0f172a' }, children: alert.seniorName }), _jsx(Chip, { size: 'small', label: risk.label, sx: {
                                                            height: 20,
                                                            fontSize: '0.65rem',
                                                            fontWeight: 700,
                                                            backgroundColor: risk.chipBg,
                                                            color: risk.chipColor,
                                                        } }), _jsx(Chip, { size: 'small', label: alert.category, sx: {
                                                            height: 20,
                                                            fontSize: '0.65rem',
                                                            fontWeight: 700,
                                                            backgroundColor: '#ede9fe',
                                                            color: '#6d28d9',
                                                        } }), _jsx(Tooltip, { title: alert.lastReadingFull, arrow: true, placement: 'top', children: _jsx(Chip, { size: 'small', icon: _jsx(AccessTimeIcon, { sx: { fontSize: '13px !important' } }), label: alert.lastReading, sx: {
                                                                height: 20,
                                                                fontSize: '0.65rem',
                                                                backgroundColor: '#f1f5f9',
                                                                color: '#475569',
                                                                cursor: 'default',
                                                            } }) })] }), _jsx(Typography, { component: 'div', sx: { fontSize: '0.9rem', color: '#1e293b', mt: 0.75 }, children: alert.message }), _jsxs(Box, { sx: {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 0.5,
                                                    mt: 0.75,
                                                    color: '#64748b',
                                                    fontSize: '0.72rem',
                                                }, children: [_jsx(DevicesOtherIcon, { sx: { fontSize: 14 } }), alert.occurredAt, " \u2022 ", alert.source] })] }), rowLoading ? (_jsx(CircularProgress, { size: 20, sx: { color: BRAND, mr: 2 } })) : (_jsx(Button, { variant: 'outlined', size: 'small', onClick: function (e) { return openMenu(e, alert); }, disabled: options.length === 0 || isStatusChangeDisabled, endIcon: _jsx(KeyboardArrowDownIcon, {}), sx: {
                                            textTransform: 'none',
                                            fontWeight: 700,
                                            fontSize: '0.75rem',
                                            borderRadius: '8px',
                                            color: BRAND,
                                            borderColor: BRAND,
                                            whiteSpace: 'nowrap',
                                            '&:hover': { borderColor: BRAND_DARK, backgroundColor: 'rgba(50,96,47,0.06)' },
                                        }, children: options.length === 0 ? 'No actions' : 'Change status' }))] }, (_a = alert.id) !== null && _a !== void 0 ? _a : idx));
                        })) })] }), _jsxs(Box, { sx: {
                    px: 3,
                    py: 1.5,
                    borderTop: '1px solid #e2e8f0',
                    backgroundColor: '#f8fafc',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 2,
                    flexWrap: 'wrap',
                }, children: [_jsx(Typography, { component: 'div', sx: { fontSize: '0.72rem', color: '#64748b' }, children: summaryText }), totalPages !== null ? (_jsx(Pagination, { count: totalPages, page: page, onChange: function (_, value) { return setPage(value); }, disabled: loading, shape: 'rounded', size: 'small', showFirstButton: true, showLastButton: true, sx: {
                            '& .MuiPaginationItem-root.Mui-selected': {
                                backgroundColor: BRAND,
                                color: '#fff',
                                '&:hover': { backgroundColor: BRAND_DARK },
                            },
                        } })) : (
                    // Fallback when the API doesn't return a total: simple Prev / Next
                    _jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1 }, children: [_jsx(Button, { size: 'small', variant: 'outlined', disabled: page <= 1 || loading, onClick: function () { return setPage(function (p) { return p - 1; }); }, sx: { textTransform: 'none', color: BRAND, borderColor: BRAND }, children: "Previous" }), _jsxs(Typography, { sx: { fontSize: '0.78rem', fontWeight: 700, color: '#475569' }, children: ["Page ", page] }), _jsx(Button, { size: 'small', variant: 'outlined', disabled: !hasMore || loading, onClick: function () { return setPage(function (p) { return p + 1; }); }, sx: { textTransform: 'none', color: BRAND, borderColor: BRAND }, children: "Next" })] }))] }), _jsx(Menu, { anchorEl: menuAnchor, open: Boolean(menuAnchor), onClose: closeMenu, children: menuOptions.map(function (status) { return (_jsxs(MenuItem, { dense: true, onClick: function () { return changeStatus(status); }, sx: { fontSize: '0.8rem', color: ACTION_COLOR[status] }, children: [_jsx(Box, { sx: {
                                width: 8,
                                height: 8,
                                borderRadius: '50%',
                                backgroundColor: ACTION_COLOR[status],
                                display: 'inline-block',
                                mr: 1,
                                flexShrink: 0,
                            } }), ACTION_LABEL[status]] }, status)); }) })] }));
};
export default RecentAlertsDialog;
